import { Box, Icon, Typography } from '@mui/material'
import { ProblematicType } from './Drawer/ErrorInsightsThemeDrawer'
import ErrorItemChip from './ErrorItemChip'

interface ErrorCardProps {
  title: string
  error: string
  errorCharge: number
  type: ProblematicType
  loading?: boolean
  onClick?: (title: string) => void
}

const ErrorCard = ({ title, error, errorCharge, type, loading, onClick }: ErrorCardProps) => {
  return (
    <Box
      border="1px solid #E6E6E6"
      borderRadius="4px"
      p={2}
      display="flex"
      flexDirection="column"
      gap={1}
      height="100%">
      <Icon sx={{ color: '#000', fontSize: '20px' }}>
        {type === 'theme' && 'label'}
        {type === 'item' && 'category'}
        {type === 'location' && 'museum'}
      </Icon>
      <Box
        display="flex"
        flexDirection="column"
        gap={0.5}>
        <Typography
          fontSize={12}
          color="#000">
          {title}
        </Typography>
        <Box
          height="30px"
          display="flex"
          alignItems="center">
          <ErrorItemChip
            type={type}
            error={error}
            errorCharge={errorCharge}
            loading={loading}
            onClick={onClick}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default ErrorCard
